module.exports = __webpack_public_path__ + "static/media/austin.23afbf38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cities/austin.jpg
// module id = 517
// module chunks = 0